import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import TextFormat from './plugins/textformat'
import VueEvents from 'vue-events'
import ToggleButton from 'vue-js-toggle-button'

// import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'

Vue.router = router
Vue.use(VueAxios, axios)

Vue.use(NProgress)

Vue.use(TextFormat)

Vue.use(VueEvents)

Vue.use(ToggleButton)

// Enable devtools
Vue.config.devtools = true
//2024/5/24
Vue.config.silent = true;


sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

// const { state } = store
//
// router.beforeEach((route, redirect, next) => {
//   if (state.app.device.isMobile && state.app.sidebar.opened) {
//     store.commit(TOGGLE_SIDEBAR, false)
//   }
//   /* route.auth && (route.router.app.$store.state.token === 'null') */
//   if (state.app.authenticated === false && route.name !== 'Login') {
//     next({
//       path: '/login',
//       query: { redirect: route.fullPath }
//     })
//   } else {
//     next()
//   }
// })

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js